module.exports = __webpack_public_path__ + "images/category_lp/pc/step2_818e3c36f0cde31ce449424a80192eba.png";